import React from 'react';
import Switch from '@mui/material/Switch';

/** Boolean switch control. `embedded` keeps spacing compact inside bordered cards (e.g. ToggleCard). */
export function SegmentedBool({ value, onChange, embedded = false }) {
  return (
    <Switch
      checked={value === true}
      onChange={(e) => onChange(e.target.checked)}
      inputProps={{ 'aria-label': 'Toggle setting' }}
      sx={{
        m: embedded ? 0 : '2px 0',
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: '#ff7a28',
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: '#ffb98b',
          opacity: 1,
        },
      }}
    />
  );
}
